import { render, staticRenderFns } from "./TeamEmpty.vue?vue&type=template&id=7b6b08f4&"
import script from "./TeamEmpty.vue?vue&type=script&lang=js&"
export * from "./TeamEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports